import apiClient from '../../api/apiClient';

export const getOemPartnerApi = async (id) => {
  const response = await apiClient.get(`/partners/oem-partners/${id}/profile`);
  return response.data.response;
};

export const sendEmailApi = async (emailData) => {
  const response = await apiClient.post('/partners/oem-partners/send-email', emailData);
  return response.data;
};